import { Dialog } from '@angular/cdk/dialog';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthSession } from '@navify-platform/auth';
import { Components } from '@one/web-components';
import { NavifyService } from 'src/app/auth/services/navify.service';
import { EndorLoginComponent } from 'src/app/shared/component/endor-login/endor-login.component';
import { EnclaveService } from 'src/app/shared/services/enclave.service';
import { LabelService } from 'src/app/shared/services/label.service';
import { SnackBarService } from 'src/app/shared/services/snackbar.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false
})
export class HeaderComponent implements OnInit {
  @ViewChild('tooltipElementProfile', { static: true })
  tooltipElementProfile!: Components.OwcTooltip;

  @ViewChild('tooltipElementEndor', { static: true })
  tooltipElementEndor!: Components.OwcTooltip;

  i18n = this.labelService.labels;
  displayName!: string;
  sessionInfo!: AuthSession;
  configured:boolean=false;
  isEndorRedirecting: boolean = false;
  
  constructor(
    private readonly nanvifyService: NavifyService,
    private readonly router: Router,
    private readonly dialog: Dialog,
    private readonly labelService: LabelService,
    private readonly enclaveService: EnclaveService,
    private readonly snackBarService: SnackBarService
  ) { }

  ngOnInit() {
    this.sessionInfo = this.nanvifyService.sessionInfo;
  }

  logout(){
    this.router.navigate(['logout'])
  }

  endorLogin(){
      this.dialog.open(EndorLoginComponent,
        {
          data: {event:'login'}
        })
  }
  visibleChangeHandler(event: CustomEvent){
    if(event.detail){
      this.tooltipElementProfile.visible = false;
       if(this.enclaveService.enclaveDetails){
          this.configured = this.enclaveService.isConfigured();
        }
      if(this.enclaveService.endorCheckValidity){
        this.configured = false;
      }
      if (this.router.url.includes('u1')) {
        this.configured = false;
      }
    }
  }

  redirectToEndor() {
    if (this.tooltipElementEndor) {
      this.tooltipElementEndor.visible = false;
    }
    
    if (this.isEndorRedirecting) {
      return; // Prevent multiple clicks
    }
    
    this.isEndorRedirecting = true;
    
    this.enclaveService.getEndorUrl().subscribe({
      next: (response) => {
        this.isEndorRedirecting = false;
        if (response.result && response.result.length > 0) {
          const endorUrl = response.result[0];
          window.open(endorUrl, '_blank', 'noopener,noreferrer');
        }
      },
      error: (error) => {
        this.isEndorRedirecting = false;
        this.snackBarService.displaySnackBar(
          this.i18n.TOAST.TECHNICAL_ERR, 'alert');
      }
    });
  }

}
